import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * 複数行テキスト入力フィールド
 *【ラベル内容:labelContent:string】
 *【内容:content:string】
 *【プレースホルダ:placeholder:string】
 *【表示条件:visible:boolean】
 *【リサイズ:resize:string】
 *【非活性:disabled:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-multiple-line-input-field',
  templateUrl: './multiple-line-input-field.html',
  styles: [`
    
  `]
})
export class MultipleLineInputField extends BaseWidget {
  /**
   * 内容の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 内容に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * 内容
   */
  @Input() content:string

  /**
   * プレースホルダ
   */
  @Input() placeholder:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * リサイズ
   */
  @Input() resize:string

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * 内容を更新する
   * @param data 
   */
  onValueChange(data) {
    if (this.content !== data) {
      this.on("change");
    }
    this.content = data;
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => this.content,
      {id:this.id, type:"change", source:new Event("change")},
      `update by ${this.id}`,
    ))
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/multiple-line-input-field/multiple-line-input-field.component.ts